import React, { Suspense, lazy, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import HomePage from "./pages/HomePage";
import AuthCallback from "./pages/AuthCallback";
import { CookieConsent } from "./components/CookieConsent";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const DriverDashboard = lazy(() => import("./pages/DriverDashboard"));
const TripPage = lazy(() => import("./pages/TripPage"));
const SharedTripPage = lazy(() => import("./pages/SharedTripPage"));
const Pricing = lazy(() => import("./pages/Pricing"));
const PaymentReturn = lazy(() => import("./pages/PaymentReturn"));
const FAQ = lazy(() => import("./pages/FAQ"));
const ForDrivers = lazy(() => import("./pages/ForDrivers"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const Privacybeleid = lazy(() => import("./pages/legal/Privacybeleid"));
const Cookiebeleid = lazy(() => import("./pages/legal/Cookiebeleid"));
const AlgemeneVoorwaarden = lazy(() => import("./pages/legal/AlgemeneVoorwaarden"));
const VoorBedrijven = lazy(() => import("./pages/VoorBedrijven"));
const VoorHotels = lazy(() => import("./pages/VoorHotels"));
const SchipholTaxiAlmere = lazy(() => import("./pages/SchipholTaxiAlmere"));
const SchipholTaxiGooi = lazy(() => import("./pages/SchipholTaxiGooi"));
const PremiumTaxiAmsterdam = lazy(() => import("./pages/PremiumTaxiAmsterdam"));

function AppRouter() {
  const location = useLocation();
  // Scroll to top on every route change (with hash anchors honored)
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    // SPA page_view voor Google Analytics (alleen als consent geladen is)
    if (typeof window !== "undefined" && window.__starwaysGaLoaded && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.hash, location.search]);
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/driver" element={<DriverDashboard />} />
      <Route path="/trip/:booking_id" element={<TripPage />} />
      <Route path="/rit/:share_token" element={<SharedTripPage />} />
      <Route path="/payment-return" element={<PaymentReturn />} />
      <Route path="/veelgestelde-vragen" element={<FAQ />} />
      <Route path="/tarieven" element={<Pricing />} />
      <Route path="/voor-chauffeurs" element={<ForDrivers />} />
      <Route path="/wachtwoord-vergeten" element={<ForgotPassword />} />
      <Route path="/wachtwoord-resetten" element={<ResetPassword />} />
      <Route path="/algemene-voorwaarden" element={<AlgemeneVoorwaarden />} />
      <Route path="/privacybeleid" element={<Privacybeleid />} />
      <Route path="/cookiebeleid" element={<Cookiebeleid />} />
      <Route path="/voor-bedrijven" element={<VoorBedrijven />} />
      <Route path="/voor-hotels" element={<VoorHotels />} />
      <Route path="/schiphol-taxi-almere" element={<SchipholTaxiAlmere />} />
      <Route path="/schiphol-taxi-gooi" element={<SchipholTaxiGooi />} />
      <Route path="/premium-taxi-amsterdam" element={<PremiumTaxiAmsterdam />} />
      <Route path="*" element={<HomePage />} />
    </Routes>
    </Suspense>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <CookieConsent />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
